__turbopack_context__.v({
  "LogSignUp": "login-module__WEZH7G__LogSignUp",
  "LoginsocialIcon": "login-module__WEZH7G__LoginsocialIcon",
  "SetSpace": "login-module__WEZH7G__SetSpace",
  "checkTpolicy": "login-module__WEZH7G__checkTpolicy",
  "checkboxed": "login-module__WEZH7G__checkboxed",
  "continue": "login-module__WEZH7G__continue",
  "error": "login-module__WEZH7G__error",
  "forget": "login-module__WEZH7G__forget",
  "loginBtn": "login-module__WEZH7G__loginBtn",
  "loginSec": "login-module__WEZH7G__loginSec",
  "rmrgin": "login-module__WEZH7G__rmrgin",
  "shake-animation": "login-module__WEZH7G__shake-animation",
  "signUpSec": "login-module__WEZH7G__signUpSec",
  "socialLogin": "login-module__WEZH7G__socialLogin",
});
